<span mat-dialog-title translate>batch.not.invoiced</span>
<div mat-dialog-content>
	<p>
		<span translate>batch.not.invoiced.sorry</span> <b *ngIf="claimedBatch">&nbsp;{{'('+claimedBatch+').'}}</b>
	</p>
	<p translate>batch.not.invoiced.select.other</p>
</div>
<div mat-dialog-actions>
	<button type="button" mat-stroked-button [mat-dialog-close]="true" color="primary" copoFocusMe>
		<span translate>eoffer.feasibility.yes</span>
	</button>
</div>
